import { css } from 'styled-components';
import { breakpoint, sizes } from 'variables';

export const hideOnMobile = css`
    display: none;

    ${breakpoint.up(sizes.lg)} {
        display: flex;
    }
`;

export const hideOnDesktop = css`
    display: flex;

    ${breakpoint.up(sizes.lg)} {
        display: none;
    }
`;
